<template lang="html">
  <footer>
    <a class="btn" href="#header" data-scroll>
      <img src="../assets/images/btn_pagetop.svg" alt="PAGE TOP">
    </a>
    <div>
      <img class="logo" src="../assets/images/logo_footer.svg" alt="株式会社まつや">
    </div>
    <address>〒929-1171 石川県かほく市木津ハ14番地の2<span>TEL.076-285-2222</span></address>
    <small>Copyrightⓒ 2017 Matsuya Co., Ltd. All rights reserved.</small>
  </footer>
</template>

<script>
import SmoothScroll from 'smooth-scroll'

export default {
  name: 'GlobalFooter',

  mounted () {
    this.scroll()
  },

  methods: {
    scroll () {
      const scroll = new SmoothScroll('[data-scroll]')
      return scroll.init()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";

  footer {
    position: relative;
    padding: 20px 0 10px;
    color: #fff;
    background-color: #000;

    .logo {
      width: 60vw;
      max-width: 218px;
    }

    address {
      margin-top: .5em;
      line-height: 1.3;

      font: {
        size: 1.4rem;
        style: normal;
      }

      span {
        display: inline-block;
        margin-left: .7em;
      }
    }

    small {
      display: block;
      margin-top: 1rem;
      color: #7f8080;
    }
  }

  .btn {
    display: block;
    position: absolute;
    right: 3vw;
    top: -28px;
    width: 60px;
    height: 60px;

    img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/GlobalFooter.vue?02968f3a